<template>
  <div style="min-height: 100vh; box-sizing: border-box" class="top_box">
    <!-- title -->
    <div style="padding: 0 18px">
      <div class="mineTop">
        我的
        <!-- <div class="kefus" @click="$parent.openKefu()"><img src="/static/image/iconKefu.da12a10e52caa3da81e8cbe383247f67.png" /><span>客服</span></div> -->
        <div class="kefus">
          <img class="img0"
            src="data:image/png;base64,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"
            alt="">
          <img
            src="data:image/png;base64,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"
            alt="" @click="$parent.openKefu()">
        </div>
      </div>
      <!-- user -->
      <div class="usersg">
        <div class="lesf">
          <img :src="$store.state.userInfo.avatar ? $store.state.userInfo.avatar : '/static/image/imageAvatar02@3x.png'"
            alt="" />
          <input class="inputsw" type="file" @change="onchangemd" single accept="image/gif,image/png" />
        </div>
        <div class="center" @click="$parent.goNav('/userInfo')">
          <div class="name">
            {{ $store.state.userInfo.username }}
            <img :src="`/static/style/vip${$store.state.userInfo.vip}.png`" alt="" />
          </div>
          <div class="dat">加入{{ $store.state.appInfo.title }}第{{ $store.state.userInfo.joinday }}天</div>
        </div>
        <img class="rig" @click="$parent.goNav('/userInfo')"
          src="/static/style/icoArrowGrey@2x.abc43ab099390c4587d33290a76fc15e.png" alt="" />
      </div>
      <div class="meys">
        <div class="lefs">
          <img src="/static/image/wallet.png" alt="" />
          <span>中心钱包</span>
          <div class="imsg" @click="$parent.getUserInfoShowLoding()">
            <img src="/static/style/refresh_2.98852cef4dfc05494e3f32a99e17d124.png" />
          </div>
        </div>
        <div class="meysf">
          <span>￥</span>
          {{ $store.state.userInfo.balance }}
        </div>
      </div>
      <div class="vipousf">
        <div class="box" @click="$parent.goNav('/vip')">
          <img src="/static/image/vipnew.png" alt="" />
          <div>
            <div class="nsgs">VIP特权</div>
            <div class="nsgsss">VIP PRIVILEGE</div>
          </div>
        </div>
        <div class="shu"></div>
        <div class="box" @click="$parent.goNav('/activity')">
          <img src="/static/image/giftnew.png" alt="" />
          <div>
            <div class="nsgs">豪礼赠送</div>
            <div class="nsgsss">SPREE ACTIVITY</div>
          </div>
        </div>
      </div>
    </div>
    <div class="uslis">
      <div style="box-sizing: border-box; padding: 0 12px">
        <div style="height: 24px"></div>
        <div class="thbs">
          <div class="lis" @click="$parent.goNav('/money')">
            <img src="/static/image/walletnew.png" alt="" />
            <span>我的钱包</span>
          </div>
          <div class="lis" @click="$parent.goNav('/transRecord')">
            <img src="/static/image/transactionnew.png" alt="" />
            <span>交易记录</span>
          </div>
          <div class="lis" @click="$parent.goNav('/betRecord')">
            <img src="/static/image/betnew.png" alt="" />
            <span>投注记录</span>
          </div>
          <div class="lis" @click="$parent.goNav('/userCent')">
            <img src="/static/image/settingnew.png" alt="" />
            <span>账户设置</span>
          </div>
        </div>
        <div class="bosfs">
          <div class="hgsw" @click="$parent.goNav('/message')">
            <img class="firsimg" src="/static/image/ob@2x.png" alt="" />
            <span class="tit">消息中心</span>
            <span class="tisf"></span>
            <img class="rigiong" src="/static/style/icoArrowGrey@2x.abc43ab099390c4587d33290a76fc15e.png" alt="" />
          </div>

          <div class="hgsw" @click="$parent.goNav('/fanshui')">
            <img class="firsimg" src="/static/image/haoyou.svg" alt="" />
            <span class="tit">返水中心</span>
            <span class="tisf"></span>
            <img class="rigiong" src="/static/style/icoArrowGrey@2x.abc43ab099390c4587d33290a76fc15e.png" alt="" />
          </div>
          <div class="hgsw" @click="$parent.goNav('/activityRecord')">
            <img class="firsimg" src="/static/image/help.png" alt="" />
            <span class="tit">活动记录</span>
            <span class="tisf"></span>
            <img class="rigiong" src="/static/style/icoArrowGrey@2x.abc43ab099390c4587d33290a76fc15e.png" alt="" />
          </div>
          <div class="hgsw" @click="$parent.goNav('/welfare')">
            <img class="firsimg" src="/static/image/haoyou.svg" alt="" />
            <span class="tit">福利中心</span>
            <span class="tisf"></span>
            <img class="rigiong" src="/static/style/icoArrowGrey@2x.abc43ab099390c4587d33290a76fc15e.png" alt="" />
          </div>
          <div class="hgsw" v-if="$store.state.userInfo.isagent == 0" @click="$parent.goNav('/applyagent')">
            <img class="firsimg" src="/static/image/join.png" alt="" />
            <span class="tit">合营计划</span>
            <span class="tisf">加入我们，共赢财富</span>
            <img class="rigiong" src="/static/style/icoArrowGrey@2x.abc43ab099390c4587d33290a76fc15e.png" alt="" />
          </div>
          <div class="hgsw" v-if="$store.state.userInfo.isagent == 1" @click="$parent.goNav('/gamePage?dailiD=1')">
            <img class="firsimg" src="/static/image/join.png" alt="" />
            <span class="tit">代理登录</span>
            <span class="tisf"></span>
            <img class="rigiong" src="/static/style/icoArrowGrey@2x.abc43ab099390c4587d33290a76fc15e.png" alt="" />
          </div>
          <div class="hgsw" @click="$parent.goNav('/app')">
            <img class="firsimg" src="/static/image/appxiazaus.png" alt="" />
            <span class="tit">app下载</span>
            <span class="tisf"></span>
            <img class="rigiong" src="/static/style/icoArrowGrey@2x.abc43ab099390c4587d33290a76fc15e.png" alt="" />
          </div>
          <div class="hgsw" @click="$parent.goNav('/boutBallBet')">
            <img class="firsimg" src="/static/image/help.png" alt="" />
            <span class="tit">帮助中心</span>
            <span class="tisf"></span>
            <img class="rigiong" src="/static/style/icoArrowGrey@2x.abc43ab099390c4587d33290a76fc15e.png" alt="" />
          </div>

          <div class="hgsw" style="border: none" @click="$parent.outLogin">
            <img class="firsimg" style="width: 18px; margin-left: 3px; margin-right: 3px"
              src="/static/image/close151.png" alt="" />
            <span class="tit">退出系统</span>
            <span class="tisf"></span>
            <img class="rigiong" src="/static/style/icoArrowGrey@2x.abc43ab099390c4587d33290a76fc15e.png" alt="" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'mine',
  data() {
    return {
      activitylistList: [],
      bfNum: 0,
      vipLis: [],
    };
  },
  created() {
    let that = this;
    that.activitylist();
    that.uservip();
  },
  methods: {
    onchangemd(e) {
      let that = this;

      console.log(e.target.files); //这个就是选中文件信息
      let formdata = new FormData();
      Array.from(e.target.files).map(item => {
        console.log(item);
        formdata.append('file', item); //将每一个文件图片都加进formdata
      });
      //  axios.post("接口地址", formdata).then(res => { console.log(res) })
      that.$parent.showLoading();

      that.$apiFun.post('/api/uploadimg', formdata).then(res => {
        that.$parent.hideLoading();

        that.$parent.getUserInfoShowLoding();
      });
    },
    uservip() {
      let that = this;
      that.$parent.showLoading();
      that.$apiFun
        .post('/api/uservip', {})
        .then(res => {
          if (res.code != 200) {
            that.$parent.showTost(0, res.message);
          }
          if (res.code == 200) {
            that.vipLis = res.data;
            that.getbfNum();
          }
          that.$parent.hideLoading();
        })
        .catch(res => {
          that.$parent.hideLoading();
        });
    },
    getbfNum() {
      let that = this;
      let num = 0; //当前vip充值钱
      let vip = that.$store.state.userInfo.vip * 1; //当前vip等级
      that.vipLis.forEach((el, index) => {
        console.log();
        if (index == vip) {
          num = el.recharge * 1;
        }
      });
      let userMey = that.$store.state.userInfo.paysum * 1;
      let bfNum = userMey == 0 || num == 0 ? 0 : Math.round((userMey / num) * 100);
      that.bfNum = bfNum > 100 ? 100 : bfNum;
    },
    transall() {
      let that = this;
      that.$parent.showLoading();
      that.$apiFun
        .post('/api/transall', {})
        .then(res => {
          that.$parent.showTost(0, res.message);
          that.$parent.getUserInfoShowLoding();
          that.$parent.hideLoading();
        })
        .catch(res => {
          that.$parent.hideLoading();
        });
    },
    activitylist() {
      let that = this;
      let info = that.actType == '' ? {} : { type: that.actType };
      that.$parent.showLoading();
      that.$apiFun.post('/api/activitylist', info).then(res => {
        if (res.code !== 200) {
          that.$parent.showTost(0, res.message);
        }
        if (res.code === 200) {
          that.activitylistList = res.data.data;
        }
        that.$parent.hideLoading();
      });
    },
  },
  mounted() {
    let that = this;
  },
  updated() {
    let that = this;
  },
  beforeDestroy() { },
};
</script>
<style lang="scss" scoped>
.mineTop {
  height: 60px;
  line-height: 60px;
  box-sizing: border-box;
  font-size: .50667rem;
  color: #fff;
  text-align: center;
  position: relative;

  .kefus {
    position: absolute;
    top: 0;
    right: 0px;
    display: flex;
    height: 56px;
    align-items: center;
    font-size: 12px;

    .img0 {
      margin-right: .53333rem;
    }

    img {
      width: .53333rem;
      height: .53333rem;
    }

    span {
      padding-top: 6px;
    }
  }
}

.usersg {
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #5d75a2;

  .lesf {
    width: 60px;
    position: relative;
    margin-right: 20px;

    img {
      width: 1.6rem;
      height: 1.6rem;
      border-radius: 50%;
    }
  }

  .center {
    flex: 1;

    .name {
      font-size: 16px;
      font-weight: 700;

      img {
        width: 30px;
        margin-left: 10px;
      }
    }

    .dat {
      font-size: 12px;
      margin-top: 8px;
      color: #a2aec8;
    }
  }

  .rig {
    width: 10px;
  }
}

.meys {
  display: flex;

  align-items: center;
  justify-content: space-between;
  margin: 0 auto;
  margin-top: 10px;
  padding: 0 12px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  width: 94%;
  height: 36px;
  background-image: url(/static/style/walletbg.27f1624304433214845615bf9bc121e3.png);
  background-repeat: no-repeat;
  background-position: top;
  background-size: 100% 100%;
  color: #fff;

  .lefs {
    display: flex;
    align-items: center;
    font-size: 12px;

    img {
      width: 18px;
    }

    span {
      padding: 0 6px;
    }

    .imsg {
      background: url(/static/image/refresh_1.png) no-repeat;
      background-size: 100% 100%;
      width: 14px;
      height: 14px;
      display: flex;
      justify-content: center;
      align-items: center;

      img {
        width: 6px;
      }
    }
  }

  .meysf {
    font-size: 16px;
    font-weight: 700;

    span {
      font-size: 8px;
      font-weight: 100;
    }
  }
}

.vipousf {
  position: relative;
  display: flex;
  justify-content: space-between;
  background: url(/static/image/itembg01.9f4ff0731e793011f46663dbfdbfd903.9f4ff073.png) no-repeat;
  background-size: 100% 100%;
  margin: 0 auto;
  border-radius: 4px;
  width: 100%;
  height: 80px;
  -webkit-box-shadow: 0 0.04rem 0.2rem 0 rgb(93 114 162 / 11%);
  box-shadow: 0 0.04rem 0.2rem 0 rgb(93 114 162 / 11%);
  box-sizing: border-box;
  padding-top: 5px;
  padding-bottom: 10px;

  .box {
    display: flex;
    flex: 1;
    justify-content: center;
    align-items: center;

    img {
      width: 38px;
      margin-right: 10px;
    }

    .nsgs {
      font-weight: 600;
      font-size: 14px;
      color: #5d75a2;
    }

    .nsgsss {
      color: #a5a9b3;
      font-size: 8px;
      margin-top: 6px;
    }
  }

  .shu {
    width: 1px;
    display: block;
    background: rgba(170, 184, 209, 0.2);
    height: 100%;
  }
}

.uslis {
  background: url(/static/image/bg2.16978ccb7fd03b3f524222a8425d3728.16978ccb.png) no-repeat;
  background-size: 100% 100%;
  width: 100%;
  margin-top: -20px;
  z-index: 200;
  position: relative;
  padding-bottom: 98px;

  .thbs {
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-sizing: border-box;
    padding: 0 16px;

    .lis {
      img {
        display: block;
        margin: 0 auto;
        width: 44px;
      }

      span {
        display: block;
        text-align: center;
        font-size: 12px;
        color: #5d75a2;
      }
    }
  }

  .bosfs {
    margin-top: 15px;
    border-radius: 15px;
    padding: 4px 12px;
    box-sizing: border-box;
    width: 100%;
    background: url(/static/image/list_bg.3577119be3c948988e7d77700fa0cc7d.3577119b.png) no-repeat;
    background-size: 100% 100%;
    -webkit-box-shadow: 0 0.04rem 0.2rem 0 rgb(93 114 162 / 11%);
    box-shadow: 0 0.04rem 0.2rem 0 rgb(93 114 162 / 11%);

    .hgsw {
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 40px;
      box-sizing: border-box;
      border-bottom: 1px solid #f5f0f0;

      .firsimg {
        width: 24px;
      }

      .tit {
        color: #4e6693;
        margin-left: 10px;
      }

      .tisf {
        flex: 1;
        margin: 0 12px;
        color: #a2aec8;
        text-align: right;
      }

      .rigiong {
        width: 6px;
      }
    }
  }
}

.top_box {
  width: 100%;
  background-image: url(/static/image/personbg.png);
  background-size: 100% auto;
  background-position: top;
  background-repeat: no-repeat;
}
</style>